import React, { FC } from 'react';
import { useSettings } from '@wix/tpa-settings/react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { Text, TextButton } from 'wix-ui-tpa';

import { SectionHeader } from '../../common/SectionHeader';
import settingsParams from '../../../settingsParams';
import { classes } from './LoginInfo.st.css';
import { DataHook } from '../../../../../constants/DataHook';
import { Divider } from '../../common/Divider';
import { LoginEmail } from '../Account/LoginEmail';

export const LoginInfo: FC = () => {
  const settings = useSettings();
  const { t } = useTranslation();

  return (
    <div className={classes.root} data-hook={DataHook.LoginInfoSection}>
      <SectionHeader
        title={settings.get(settingsParams.loginInfoSectionTitle)}
        subtitle={settings.get(settingsParams.loginInfoSectionSubtitle)}
      />
      <LoginEmail />
      <Text tagName="div">{t('app.widget.login-password.title')}:</Text>

      <Text tagName="div">⏺ ⏺ ⏺ ⏺ ⏺ ⏺</Text>
      <TextButton>{t('app.widget.login-password.change-button')}</TextButton>
      <Divider />
    </div>
  );
};
